<template>
    <div>
        <v-snackbar v-model="showInstallApp" class="kit-install" color="transparent" content-class="kit-content" bottom
            right :timeout="5000">
            <toast-card clickable icon="mdi-cellphone-arrow-down" :text="$t('common.install_app')"
                @click.native="installApp" @close="showInstallApp = false" />
        </v-snackbar>

        <v-snackbar v-model="showInstallAppIos" color="transparent" content-class="kit-content" :timeout="-1"
            :class="['kit-ios', { 'kit-ios--arrow': showInstallAppIos }]">
            <toast-card clickable icon="mdi-export-variant" @click.native="showInstallAppIos = false"
                @close="showInstallAppIos = false">
                {{ $t('common.install_app_ios_1') }}
                <v-icon size="16" color="secondary">mdi-export-variant</v-icon>
                {{ $t('common.install_app_ios_2') }}
            </toast-card>
        </v-snackbar>
    </div>
</template>

<script>
import ToastCard from "@/components/common/ToastCard";
import { Device } from "@/utils/Capacitor";

export default {
    name: "KimsaInstallToast",
    components: { ToastCard },
    data() {
        return {
            showInstallApp: false,
            showInstallAppIos: false,
        }
    },
    mounted() {
        const vm = this
        vm.showInstallAppMessage().catch(() => { })
    },
    beforeDestroy() {
        if (this._onInstallPrompt) window.removeEventListener("beforeinstallprompt", this._onInstallPrompt)
    },
    methods: {
        async showInstallAppMessage() {
            const vm = this
            // SHOW ALERT IF DONT HAVE INSTALLED APP AND DESKTOP
            if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                vm._onInstallPrompt = event => {
                    setTimeout(() => {
                        vm.showInstallApp = true
                    }, 3000)
                    window.deferedPrompt = event;
                }
                window.addEventListener("beforeinstallprompt", vm._onInstallPrompt);
            }

            // Detects if device is on iOS and show Message
            const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
            if (await Device.isIphone() && !isInStandaloneMode()) vm.showInstallAppIos = true
        },
        installApp() {
            const vm = this
            const promptEvent = window.deferedPrompt;
            if (!promptEvent) return vm.showInstallApp = false
            promptEvent.prompt()
            promptEvent.userChoice.then(result => {
                result.outcome === 'accepted' ?
                    console.log('User accept the prompt') :
                    console.log('User dismissed the prompt')
                vm.showInstallApp = false;
                window.deferedPrompt = null;
            });
        }
    }
}
</script>

<style scoped>
::v-deep .v-snack__wrapper {
    background: transparent !important;
    box-shadow: none !important;
    min-width: 0;
    margin-bottom: var(--safe-area-inset-bottom, 0px);
}

::v-deep .kit-content {
    padding: 0;
    width: 100%;
}

.kit-install ::v-deep .v-snack__wrapper {
    margin-bottom: calc(24px + var(--safe-area-inset-bottom, 0px));
    margin-right: 8px;
}

.kit-ios {
    position: fixed !important;
    top: -28px !important;
}

.kit-ios--arrow::before {
    content: "";
    width: 16px;
    height: 16px;
    transform: rotate(-45deg);
    background: var(--v-surface-base);
    border-right: 1px solid var(--v-outline-base);
    border-bottom: 1px solid var(--v-outline-base);
    position: absolute;
    z-index: 10;
    bottom: 2px;
    left: calc(50% - 8px);
}
</style>
